import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import './css/footer.css';

export default ()=> (
    <div id="footer">
        <small>&copy; 2018 Gran Canaria Ecológica - <Link to="/terms">Terminos y Condiciones</Link></small>
    </div>
)


// WEBPACK FOOTER //
// ./src/Footer.js